export const dollar = (value) => {
	if (!value) return '$0'
	let floatValue = parseFloat(value)
	let isNegative = floatValue < 0;
	let absValue = Math.abs(floatValue);

	value = isNegative ? '-$' : '$';
	value += absValue.toFixed(2);
	value += isNegative ? '' : '';

	return value;
};
